// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { createFileRoute } from '@tanstack/react-router';

// material ui
import { Box, Fade, Typography } from '@mui/material';

// api
import { useGetAccountsQuery } from '@/api/recalc/endpoints/accountsApiSlice';

// shared components
import PageContainer from '@/components/layout/PageContainer';
import LinearLoadingIndicator from '@/components/ui/progress/LinearLoadingIndicator';

// feature-components
import HomeGreetingBadge from '@/features/landing-page/components/HomeGreetingBadge';

// components
import { useSessionAuth } from '@/contexts/SessionAuthContext';
import ErrorBoundary from '@/routes/-ErrorBoundary.tsx';

export const Route = createFileRoute('/$accountId/')({
  component: RouteComponent,
  errorComponent: ErrorBoundary,
});

function RouteComponent() {
  const { t } = useTranslation('home');
  const { session: sessionData } = useSessionAuth();
  const email = sessionData?.claims?.email || '';
  const { isLoading } = useGetAccountsQuery();

  return (
    <>
      <LinearLoadingIndicator isLoading={isLoading} />

      <Fade in={!isLoading} timeout={900}>
        <Box component="section" sx={{ py: { xs: 8, md: 12 } }}>
          <PageContainer>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
              }}
            >
              <HomeGreetingBadge email={email} />
              <Typography
                variant="h3"
                fontWeight="bold"
                sx={{ letterSpacing: '-0.02em' }}
              >
                {t('home.heroTitle')}
              </Typography>
            </Box>
          </PageContainer>
        </Box>
      </Fade>
    </>
  );
}
